import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.dashboard.getStats(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchDashboardRecent = createAsyncThunk(
  'dashboard/fetchRecent',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.dashboard.getRecent(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  stats: [],
  recentActivities: [],
  recentInvoices: [],
  activePromotions: [],
  templateStatus: { approved: 0, pending: 0, rejected: 0, total: 0 },
  pendingTasks: [],
  topCustomers: [],
  statsLoading: false,
  recentLoading: false,
  statsError: null,
  recentError: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.statsError = null;
      state.recentError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.statsLoading = true;
        state.statsError = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload.data?.stats || [];
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.statsLoading = false;
        state.statsError = action.payload?.message || action.payload || 'Failed to load stats';
      })
      .addCase(fetchDashboardRecent.pending, (state) => {
        state.recentLoading = true;
        state.recentError = null;
      })
      .addCase(fetchDashboardRecent.fulfilled, (state, action) => {
        state.recentLoading = false;
        const data = action.payload.data || {};
        state.recentActivities = data.recentActivities || [];
        state.recentInvoices = data.recentInvoices || [];
        state.activePromotions = data.activePromotions || [];
        state.templateStatus = data.templateStatus || { approved: 0, pending: 0, rejected: 0, total: 0 };
        state.pendingTasks = data.pendingTasks || [];
        state.topCustomers = data.topCustomers || [];
      })
      .addCase(fetchDashboardRecent.rejected, (state, action) => {
        state.recentLoading = false;
        state.recentError = action.payload?.message || action.payload || 'Failed to load recent data';
      });
  },
});

export const { clearErrors } = dashboardSlice.actions;
export default dashboardSlice.reducer;
